import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {path: '/', name: 'landing', component: () => import( /* webpackChunkName: "Landing" */ '@/components/landing/Landing')},
    {path: '/about', name: 'about', component: () => import( /* webpackChunkName: "About" */ '@/components/about/About')},
    {path: '/catalog', name: 'catalog', component: () => import( /* webpackChunkName: "Catalog" */ '@/components/catalog/Catalog')},
    {path: '/service', name: 'service', component: () => import( /* webpackChunkName: "Service" */ '@/components/service/Service')},
    {path: '/engineering', name: 'engineering', component: () => import( /* webpackChunkName: "Engineering" */ '@/components/engineering/Engineering')},
    {path: '/contacts', name: 'contacts', component: () => import( /* webpackChunkName: "Contacts" */ '@/components/contacts/Contacts')},
  ]
})

router.beforeEach((to, from, next) => {
  if (!to.query.lang){
    to.query.lang = localStorage.getItem('lang') || 'nl';
    next({ path: to.path, query: to.query });
  }
  else {
    next()
  }

});

export default router